import apiConfig from '../api-config'
import { storeManager } from 'Store/storeManager'

export class BaseController {
  readonly apiHost: string
  // readonly apiPath: string
  readonly apiAccount: string
  readonly apiPathDigitalId: string
  fetchController: Record<string, any>

  constructor () {
    const isGlobalEnabled = storeManager.getIsGlobalEnabled()
    let configKey = (isGlobalEnabled ? 'global': 'regional') as keyof typeof apiConfig

    this.apiHost = apiConfig[configKey].apiHost ?? ''
    // this.apiPath = appConfig.regions[0].api.paths.account
    this.apiAccount = apiConfig[configKey].paths.account ?? ''
    this.apiPathDigitalId = apiConfig[configKey].paths.digitalId ?? ''
    this.fetchController = {}
  }

  async getHeaders (method: string, file: boolean = false, impersonateKerb: string = ''): Promise<Headers> {
    const token = sessionStorage.getItem('AccessToken') ?? ''

    const headers: Headers = new Headers()
    headers.append('Authorization', token)

    if (file) {
      headers.append('Content-Type', 'image/png')
    } else {
      headers.append('Content-Type', 'application/json')
    }

    if (impersonateKerb !== '') {
      headers.append('X-Impersonated-User', impersonateKerb)
    }

    return headers
  }

  async useFetchWithoutHeaders (
    method: string,
    fetchKey: string,
    url: string
  ): Promise<any> {

    if (this.fetchController[fetchKey] !== null && this.fetchController[fetchKey] !== undefined) {
      this.fetchController[fetchKey].abort()
    }

    this.fetchController[fetchKey] = new AbortController()
    const { signal } = this.fetchController[fetchKey]

    const options: any = {
      method: method,
      signal
    }

    const response = await fetch(url, options)

    // clear out controller
    this.fetchController[fetchKey] = null

    return response
  }

  async useFetch (
    method: string,
    fetchKey: string,
    url: string,
    body: any = null,
    file: boolean = false,
    impersonateKerb: string = ''
  ): Promise<any> {

    if (this.fetchController[fetchKey] !== null && this.fetchController[fetchKey] !== undefined) {
      this.fetchController[fetchKey].abort()
    }

    this.fetchController[fetchKey] = new AbortController()
    const { signal } = this.fetchController[fetchKey]

    const options: any = {
      method: method,
      headers: await this.getHeaders(method, file, impersonateKerb),
      signal
    }
    if (body !== null) {
      options.body = file ? body : JSON.stringify(body)
    }

    const response = await fetch(url, options)

    const refereshToken = response.headers.get('x-authorization-refresh')
    if (refereshToken !== null) {
      sessionStorage.setItem('AccessToken', refereshToken)
    }

    // clear out controller
    this.fetchController[fetchKey] = null

    return response
  }

  // async logout (): Promise<void> {
  //   await new AuthProviderLocal().logout()
  // }
}
